module.exports = (s) => {
  return [
    {
      name: 'ID',
      value: 'id',
      props: {
        fixed: 'left',
      },
    },
    {
      name: '广告名称',
      value: 'name',
      props: {
        fixed: 'left',
        width: 100,
      },
    },
    {
      name: '所属项目ID',
      value: 'project_id',
      props: {
        fixed: 'left',
        width: 100,
      },
    },
    {
      name: '广告账户ID',
      value: 'advertiser_id',
      props: {
        width: 100,
      },
    },
    {
      name: '广告创建时间',
      value: 'promotion_create_time',
      props: {
        width: 100,
      },
    },
    {
      name: '广告更新时间',
      value: 'promotion_modify_time',
      props: {
        width: 100,
      },
    },
    {
      name: '操作状态',
      value: 'opt_status',
      props: {
        width: 100,
      },
      format: ({ opt_status }) => {
        return opt_status === 'ENABLE' ? '启用广告' : '暂停广告';
      },
    },
    {
      name: '广告来源',
      value: 'source',
      props: {
        width: 100,
      },
    },
    {
      name: '预算',
      value: 'budget',
      props: {
        width: 100,
      },
    },
    {
      name: '目标转化出价/预期成本',
      value: 'cpa_bid',
      props: {
        width: 100,
      },
    },
    {
      name: '深度优化出价',
      value: 'deep_cpabid',
      props: {
        width: 100,
      },
    },
    {
      name: '深度转化ROI系数',
      value: 'roi_goal',
      props: {
        width: 100,
      },
    },
    {
      name: '最后修改平台',
      value: 'status',
      format: ({ local_materials }) => {
        return local_materials ? 'MKT' : '巨量';
      },
    },
    {
      name: '广告状态',
      value: 'status',
      format: ({ status }) => {
        return s.$store.getters.jrttEnumVal.api_2_ad_status[status];
      },
    },
    {
      name: '创建时间',
      value: 'created_time',
      props: {
        width: 100,
      },
    },
    {
      name: '最后更新时间',
      value: 'updated_time',
    },
    {
      name: '操作',
      value: 'adgroup_name',
      props: {
        fixed: 'right',
        align: 'center',
        width: 200,
      },
      format: (row) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('el-button',
              {
                props: {
                  size: 'mini',
                  disabled: !row?.local_materials,
                },
                on: {
                  click: () => {
                    s.editAd(row);
                  },
                },
              },
              '编辑'
            ),
            h('el-button',
              {
                props: {
                  size: 'mini',
                  type: 'success',
                },
                on: {
                  click: () => {
                    s.$router.push({
                      path: '/superior/superior-jrtt/report/ad-report',
                      query: {
                        advertiser_id: row.advertiser_id,
                        project_id: row.project_id,
                        promotion_id: row.type_id,
                      },
                    });
                  },
                },
              },
              '查看报表'
            ),
          ]
        );

        return ele;
      },
    },
  ];
};
